<template>
  <b-card no-body class="information-box border-0 position-relative z-1" :class="[{ 'my-2 my-md-4': !isWelcome }, { 'mb-2 mb-md-3': isWelcome }]">
    <b-row no-gutters align-h="center" class="g-2">
      <b-col cols="12" :md="gridLaptopValue" v-for="(item, index) in clustersList" :key="`news-${index}`">
        <b-card no-body class="information-box__card border overflow-hidden h-100">
          <div class="information-box__media">
            <b-img-lazy :src="`${SERVER_URL}${item.picture}`" alt="" class="information-box__img" />
          </div>
          <div class="information-box__body d-flex flex-column flex-grow-1">
            <component :is="titleTag" class="information-box__title">{{ item.name }}</component>
            <div class="information-box__count">
              <span class="information-box__count-num">
                <ICountUp :delay="300" :endVal="item.count" :options="options" />
              </span>
              <span class="information-box__count-label">{{ categoryName }}</span>
            </div>
            <b-button variant="primary" class="information-box__btn" @click="searchCluster(item.id, item.name)">
              {{ item.name }}
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import ICountUp from 'vue-countup-v2';
import { SERVER_URL } from '@/config/constant';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    ICountUp,
  },
})
export default class InformationBox extends Vue {
  @Prop({ type: Array }) clustersList!: any[];

  @Prop({ default: false }) private isWelcome!: boolean;

  // Heading level of the cluster cards: on the welcome page they sit directly
  // under the page H1, elsewhere under an H2 section heading (#20271).
  @Prop({ default: 'h3' }) private titleTag!: string;

  @Prop({ required: true }) private categoryName!: string;

  SERVER_URL = SERVER_URL;

  options = {
    useEasing: true,
    useGrouping: true,
    separator: AppModule.language === 'en' ? ',' : '.',
    decimal: '.',
    prefix: '',
    suffix: '',
  };

  searchCluster(id: number, title: string) {
    this.$emit('search-cluster', { id, title });
  }

  get gridLaptopValue() {
    if (this.clustersList.length === 1) {
      return 12;
    }
    if (this.clustersList.length % 3 === 0) {
      return 4;
    }
    if (this.clustersList.length % 2 === 0) {
      return 6;
    }
    return 4;
  }
}
</script>
<style scoped lang="scss">
.information-box__card {
  border-radius: 12px;
  border-color: #e0e0e0 !important;
  transition: border-color .2s ease-in-out;

  &:hover {
    border-color: #0054A6 !important;
  }
}

.information-box__media {
  height: 176px;
  overflow: hidden;
  background: #f5f5f5;
}

.information-box__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 30%;
}

.information-box__body {
  padding: 1rem;

  @media (min-width: 576px) {
    padding: 1.25rem;
  }
}

.information-box__title {
  margin: 0;
  overflow-wrap: anywhere;
  color: #0054A6;
  font-family: Roboto, Arial, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
}

.information-box__count {
  display: flex;
  align-items: baseline;
  gap: .375rem;
  margin-top: .75rem;
  margin-bottom: 1.5rem;
}

.information-box__count-num {
  color: #333333;
  font-family: Roboto, Arial, sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
}

.information-box__count-label {
  color: #666666;
  font-family: Roboto, Arial, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
}

.information-box__btn {
  // auto притискає кнопку до низу картки, тож у всіх карток ряду вони на одній лінії
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 62px;
  width: 100%;
  padding: .625rem 1.25rem;
  border: 0;
  border-radius: .25rem;
  background-color: #0054A6 !important;
  color: #fff;
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  transition: background-color .2s ease-in-out;

  &:hover,
  &:focus,
  &:active {
    background-color: #004385 !important;
    color: #fff;
  }
}
</style>
